var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"optional-buttons"},[_c(_setup.IconBoxZzimWithApi,{attrs:{"section":_vm.contentType,"content-id":_setup.contentId,"zzim":_setup.isLikeOn}}),_c(_setup.IconBoxSnsShare,{attrs:{"content-info":_vm.contentInfo,"section":_vm.contentType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }